module.exports = "../../app/cells/components/shadow_header_cell.rb";